import React from 'react'

export default function OPLogo() {
    return (
        <svg
            width="494"
            height="385"
            viewBox="0 0 494 385"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_298_250)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M396.385 116.74H307.825H243.68H243.643C235.705 116.74 228.795 122.31 226.91 130.227L221.699 152.114H351.416L344.551 180.757C343.602 184.709 340.152 187.487 336.187 187.487H272.931C263.361 187.487 255.06 194.275 252.916 203.853L239.767 258.234H275.367L284.043 222.861H356.403C364.342 222.861 371.252 217.291 373.137 209.374L396.385 116.74Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M135.241 116.74C127.267 116.74 120.312 122.246 118.363 130.104L92.0366 236.224C89.2654 247.396 97.5769 258.234 108.914 258.234H194.275C202.249 258.234 209.203 252.728 211.152 244.871L242.939 116.74H135.241ZM154.1 152.114C150.112 152.114 146.633 154.869 145.66 158.8L132.524 211.86C131.142 217.445 135.297 222.861 140.964 222.861H175.125C179.114 222.861 182.592 220.105 183.565 216.175L199.424 152.114H154.1Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M447.586 78.8986H89.6099C89.0618 78.8986 88.5837 79.2715 88.4503 79.8032L34.725 293.809C34.6455 294.126 34.6734 294.265 34.689 294.333C34.7157 294.454 34.7879 294.637 34.9419 294.836C35.0959 295.032 35.2577 295.148 35.3674 295.203C35.4308 295.234 35.5579 295.296 35.8848 295.296H392.328C392.876 295.296 393.354 294.922 393.488 294.391L447.586 78.8986ZM89.6099 44.2274C73.1648 44.2274 58.8267 55.411 54.8225 71.3609L1.09726 285.367C-4.58789 308.012 12.5362 329.967 35.8848 329.967H392.328C408.772 329.967 423.11 318.784 427.116 302.833L492.038 44.2274H89.6099Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_298_250">
                    <rect width="493.203" height="385" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
